import { SharedState } from "@/common/state";
import { uniqby } from "@/fp";
import { BaseDashboardItem } from "./models";
import { apiCall } from "@/common/api/ApiResult.model";
import { get_finding_count } from "@/common/api/findings/findings.api";
import {
  ApplicationType,
  DataSourceType,
} from "@/views/customize/data-sources/data/model";
import { POPULATION_TYPE } from "@/common/models";

const get_counts = async (session_id: number, label_ids: string[]) => {
  return await get_finding_count({
    application: "network_file_system" as ApplicationType,
    service: "onprem_fs" as DataSourceType,
    axis_z: {
      type: "Session",
      value: session_id,
    },
    label_ids,
    type: "sensitive_information",
  });
};

export const info_type_per_l1 = apiCall<
  {
    session_id: number;
    root_folder_id: string;
  },
  { other: number; l1s: BaseDashboardItem[]; all: Record<string, number> }
  // @ts-ignore
>("on-prem.get_information_board", async ({ session_id }) => {
  const other_id = SharedState.default_label.value?.id as string;
  let other_count = 0;
  const res = await get_counts(session_id, []);
  if (res.success) {
    const other = res.value.find(({ labelId }) => labelId === other_id);
    if (other) {
      other_count = other.count;
    }

    const base = uniqby("labelId")(
      res.value.filter(({ labelId }) => {
        return SharedState.allInfoTypes.value[labelId];
      })
    );

    const all = base.reduce((acc, item) => {
      acc[item.labelId] = item.count;
      return acc;
    }, {} as Record<string, number>);

    const result = base
      .filter(({ labelId }) => {
        return SharedState.allInfoTypes.value[labelId].generation == 1;
      })
      .map(({ labelId, count }) => {
        const label = SharedState.allInfoTypes.value[labelId];
        return {
          id: label.id,
          name: label.labelName,
          count,
          parent_id: label.parentId,
          type: POPULATION_TYPE.LABEL,
        };
      });

    return {
      success: true,
      value: {
        all,
        l1s: result,
        other: other_count,
      },
    };
  } else {
    return {
      success: true,
      value: {
        all: {},
        l1s: [],
        other: other_count,
      },
    };
  }
});

export const get_personal_info_counts = apiCall<
  {
    personal_info_ids: string[];
    session_id: number;
    root_folder_id: string;
  },
  BaseDashboardItem[]
>(
  "on-prem.get_personal_information_board",
  async ({ personal_info_ids, session_id }) => {
    const res = await get_counts(session_id, personal_info_ids);
    if (res.success) {
      const result = uniqby("id")(
        res.value
          .filter(({ labelId }) => SharedState.allInfoTypes.value[labelId])
          .map(({ count, labelId }) => {
            const label = SharedState.allInfoTypes.value[labelId];
            return {
              id: label.id,
              name: label.labelName,
              parent_code: label.content_code,
              count,
            };
          })
      );
      return {
        success: true,
        value: result,
      };
    } else {
      return {
        success: true,
        value: [],
      };
    }
  }
);
